import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Strikte Validierung, um zu verhindern, dass "undefined" Strings als URLs verwendet werden
const isValidUrl = (url) => {
  if (!url || typeof url !== 'string' || url === 'undefined' || url === 'null') return false;
  try {
    new URL(url);
    return true;
  } catch (e) {
    return false;
  }
};

const isValidKey = (key) => {
  return key && typeof key === 'string' && key !== 'undefined' && key !== 'null' && key.trim() !== '';
};

// Singleton Client - wird nur initialisiert, wenn echte Credentials vorhanden sind
export const supabase = (isValidUrl(supabaseUrl) && isValidKey(supabaseKey)) 
  ? createClient(supabaseUrl, supabaseKey) 
  : null;

const TABLE_NAME = 'page_stats_1777567444863';

/**
 * Erhöht einen Zähler in der Datenbank
 * @param {string} key - Der eindeutige Schlüssel für die Statistik
 */
export const trackView = async (key) => {
  if (!supabase) return;
  try {
    const { error } = await supabase.rpc('increment_stat', { stat_key: key });
    if (error) console.warn('Statistik-Fehler:', error.message);
  } catch (err) {
    // Fängt "Failed to fetch" Fehler sicher ab, ohne die App zu crashen
    console.warn('Tracking fehlgeschlagen (Netzwerk oder Credentials ungültig)');
  }
};

/**
 * Ruft alle Statistiken ab
 * @returns {Promise<Array>} - Liste der Statistik-Objekte
 */
export const getStats = async () => {
  if (!supabase) return [];
  try {
    const { data, error } = await supabase.from(TABLE_NAME).select('key,count');
    if (error) throw error;
    return data || [];
  } catch (err) {
    console.warn('Stats Request fehlgeschlagen (Netzwerk oder Credentials ungültig)');
    return [];
  }
};